<div
class="video-container"
(mouseenter)="onMouseEnter()"
(mouseleave)="onMouseLeave()"
(mousemove)="onMouseMove()"
(contextmenu)="$event.preventDefault()"
>
  <video
    #videoElement
    [src]="videoSrc"
    [poster]="posterSrc"
    [id]="videoId"
    class="video-element"
    (timeupdate)="onTimeUpdate()"
    (loadedmetadata)="onLoadedMetadata()"
    (ended)="onVideoEnded()"
    (pause)="onVideoPaused()"
    (contextmenu)="$event.preventDefault()"
    preload="metadata"
    controlsList="nodownload"
    style="width: 100%; height: 100%; object-fit: contain;"
    webkit-playsinline playsinline>
  </video>

  <!-- <div class="temporary-icon lg:block" [ngClass]="showPlayPauseIcon ? 'show' : 'force-hidden'">
    <ion-icon *ngIf="playPauseIconType === 'play'" name="play" class="text-[54px] text-white"></ion-icon>
    <mat-icon *ngIf="playPauseIconType === 'pause'" class="mdi mdi-pause text-[54px]  text-white"></mat-icon>
  </div> -->

  <button
  class="flex video-play-button w-10 h-10 md:w-12 md:h-12 absolute xxl:w-14 xxl:h-14 top-1/2 left-1/2  justify-center items-center rounded-full text-white border-none"
  (click)="togglePlayPause($event)"
  [ngClass]="{
    'force-hidden-sm': !showControls
  }"
  >
      <ion-icon *ngIf="!isPlaying" name="play" class="center-player-icon text-xl leading-6 md:text-2xl lg:leading-7 xxl:text-3xl xxl:leading-8 "></ion-icon>
      <mat-icon *ngIf="isPlaying" class="mdi mdi-pause center-player-icon text-xl leading-6 md:text-2xl lg:leading-7 xxl:text-3xl xxl:leading-8 "></mat-icon>
  </button>

  <!-- speed control app  -->
  <div *ngIf="showControls" class="md:hidden absolute top-2 right-2 h-[40px] gap-[10px] flex items-center">
    <div class="relative flex items-center">
      <button class="control-btn" (click)="toggleSpeedMenu()" title="Velocidad">
        <mat-icon class="mdi mdi-speedometer player-icon"></mat-icon>
      </button>
      <div *ngIf="showSpeedMenu" class="speed-menu px-1" (mouseleave)="showSpeedMenu = false">
        <button *ngFor="let speed of speedOptions"
          class="block w-full p-1 border-none text-white cursor-pointer text-sm mb-[1px]"
          (click)="setPlaybackSpeed(speed)"
        >
          <span class="speed-option-item p-2 w-full rounded-lg flex justify-end items-center py-[4px] px-3"
          [class.active]="speed === playbackSpeed">
          {{ speed === 1 ? 'Normal' : speed +  'x' }}
          </span>
        </button>
      </div>
    </div>
  </div>

  <div class="custom-controls" [class.show]="showControls">
    <!-- Barra de progreso -->
    <ion-range aria-label="progress"
    [value]="currentTime"
    class="video-progress-bar p-0 absolute md:static bottom-0 left-0 right-0"
    (ionInput)="onRangeInput($event)"
    (ionChange)="progressBarChange($event)"
    [min]="0"
    [max]="floorDuration"
    ></ion-range>

    <!-- Controles -->
    <div class="controls-panel pb-[18px] px-3 md:pb-0">
      <div class="controls-left">
        <!-- Play/Pause -->
        <button class="force-hidden-play-btn md:block control-btn"
        (click)="togglePlayPause($event)"
        >
            <!-- <mat-icon class="gmi text-white text-xl">home</mat-icon> -->
            <ion-icon *ngIf="!isPlaying" name="play" class="player-icon"></ion-icon>
            <mat-icon *ngIf="isPlaying" class="mdi mdi-pause player-icon"></mat-icon>
        </button>

        <!-- Volumen -->
        <div class="volume-control"
        (mouseenter)="showVolumeBar = true"
        (mouseleave)="showVolumeBar = false"
        >
          <button class="control-btn" (click)="toggleMute()" title="Silenciar">
            <ion-icon [name]="getVolumeIcon()" class="player-icon"></ion-icon>
          </button>
          <input
            type="range"
            class="volume-slider"
            [class.open]="showVolumeBar"
            min="0"
            max="1"
            step="0.1"
            [value]="volume"
            (input)="changeVolume($event)">
        </div>

        <!-- Tiempo -->
        <div class="text-base whitespace-nowrap h-10 flex justify-center items-center px-4 rounded-xl bg-[#3a393996] hover:bg-[#ffffff33] pointer-events-none">
          <span>{{ formatTime(currentTime) }} / {{ formatTime(duration) }}</span>
        </div>
      </div>

      <div class="controls-right">
            <!-- speed control-->
            <div class="hidden md:flex relative items-center">
              <button class="control-btn" (click)="toggleSpeedMenu()" title="Velocidad">
                <mat-icon class="mdi mdi-speedometer player-icon"></mat-icon>
              </button>
              <div class="speed-menu px-1" *ngIf="showSpeedMenu" (mouseleave)="showSpeedMenu = false">
                <button *ngFor="let speed of speedOptions"
                  class="block w-full p-1 border-none text-white cursor-pointer text-sm mb-[1px]"
                  (click)="setPlaybackSpeed(speed)"
                >
                  <span class="speed-option-item p-2 w-full rounded-lg flex justify-end items-center py-[4px] px-3"
                  [class.active]="speed === playbackSpeed">
                  {{ speed === 1 ? 'Normal' : speed +  'x' }}
                  </span>
                </button>
              </div>
            </div>

            <!-- Picture in Picture -->
            <button class="control-btn" (click)="togglePictureInPicture()" title="Picture in Picture" >
              <mat-icon class="mdi mdi-picture-in-picture-bottom-right-outline player-icon" ></mat-icon>
            </button>

            <!-- Pantalla completa -->
            <button class="control-btn" (click)="toggleFullscreen()" title="Pantalla completa" >
              <ion-icon *ngIf="!isfullscren" name="expand" class="player-icon" ></ion-icon>
              <ion-icon *ngIf="isfullscren" name="contract" class="player-icon" ></ion-icon>
            </button>


      </div>
    </div>
  </div>
</div>
